/**
 * Constants definition.
 *
 * @type {{ONEI: string, OCPI: string}}
 */
const OCPI_TYPES = {
  ONEI: 'ONEI',
  OCPI: 'OCPI',
};

const OCPI_TYPES_ENUM = Object.keys(OCPI_TYPES);

const ONEI = OCPI_TYPES_ENUM[0];
const OCPI = OCPI_TYPES_ENUM[1];

export {
  OCPI_TYPES,
  OCPI_TYPES_ENUM,
  ONEI,
  OCPI,
};
